/** Clicking the back button in the browser closes the open modal - this prevents the user from
 * clicking the back button after any change in the modal and the page remains the same, only
 * the modal is hidden and the modal backdrop (grey background) remains. */
$(window).on('popstate', function() {
    $('.modal.fade.show').modal('hide');
    $(".modal-backdrop").remove();
});